import { Step } from "../forms/FormBondApp.constants";
import {
  StyledStepContainer,
  StyledStepWide,
  StyledLabel,
  StyledStepWideArrow,
  StyledWrapper,
} from "./StepWide.styled";

export const stepWidthMapping = {
  instructions: {
    width: "0%",
    id: 1,
  },
  start: {
    width: "0%",
    id: 1,
  },
  bondApplicant: {
    width: "10%",
    id: 1,
  },
  bondBusiness: {
    width: "10%",
    id: 1,
  },
  bondRisk: {
    width: "40%",
    id: 2,
    back: (isBusiness?: boolean) =>
      isBusiness ? Step.BOND_BUSINESS : Step.BOND_APPLICANT,
  },
  bondSpecific: {
    width: "50%",
    id: 3,
    back: () => Step.BOND_RISK,
  },
  bondAgencyQuestions: {
    width: "50%",
    id: 3,
    back: () => Step.BOND_SPECIFIC,
  },
  bondIndemnitor: {
    width: "60%",
    id: 4,
    back: () => Step.BOND_SPECIFIC,
  },
  bondOptions: {
    width: "100%",
    id: 5,
    back: () => Step.BOND_INDEMNITOR,
  },
  paymentLink: {
    width: "100%",
    id: 5,
    back: () => Step.BOND_INDEMNITOR,
  },
  bondDelivery: {
    width: "100%",
    id: 5,
  },
  bondPreview: {
    width: "100%",
    id: 5,
  },
  processing: {
    width: "100%",
    id: 6,
    back: () => Step.BOND_OPTIONS,
  },
  complete: {
    width: "100%",
    id: 6,
  },
};

export const StepWide = ({ step }: { step: Step }) => {
  const currentStep =
    stepWidthMapping[step as keyof typeof stepWidthMapping] ||
    stepWidthMapping[Step.PROCESSING];

  return (
    <StyledWrapper>
      <StyledStepContainer>
        <StyledLabel color={currentStep.id >= 4 ? "white" : "var(--primary)"}>
          Step {currentStep.id}/5
        </StyledLabel>
        <StyledStepWide></StyledStepWide>
        <StyledStepWideArrow width={currentStep.width}></StyledStepWideArrow>
      </StyledStepContainer>
    </StyledWrapper>
  );
};
